import { computed } from "vue";

export function useQuantcast() {
    function pageViewEvent(email: string) {
        if(typeof window == 'undefined') return;
        window._qevents = window._qevents || [];
        let event = {
            "qacct": "p-2Yus2kPNs5Wu8",
            "labels": "_fp.event.PageView",
        }
        if(email) {
            event.uid = email;
        }
        window._qevents.push(event);
    }

    function purchaseEvent({email, orderId, total}: {email: string, orderId: string, total: number}) {
        if(typeof window == 'undefined') return;
        window._qevents = window._qevents || [];
        let event = {
            "qacct": "p-2Yus2kPNs5Wu8",
            "labels": "_fp.event.Purchase",
            "orderid": orderId,
            "revenue": total,
        }
        if(email) {
            event.uid = email;
        }
        window._qevents.push(event);
    }

    return {
        pageViewEvent,
        purchaseEvent,
    }
}